import type { Metric } from "./types";

export const starterMetrics: Metric[] = [
  {
    id: "metric-gross-margin",
    name: "gross_margin_pct",
    displayName: "Gross Margin %",
    description:
      "Revenue-weighted gross margin calculated as (revenue - cost of goods sold) divided by revenue.",
    domain: "Corporate Finance",
    owner: "Corporate Finance",
    source: "Snowflake — Corporate Analytics",
    table: "FINANCE.PRODUCT_PERFORMANCE",
    expression: "(SUM(REVENUE) - SUM(COGS)) / NULLIF(SUM(REVENUE), 0) * 100",
    aggregation: "Calculated ratio",
    unit: "Percent",
    grain: "Product · month",
    dimensions: ["Product", "Category", "Business Unit", "Fiscal Month"],
    synonyms: ["margin", "gross profit percentage", "product margin"],
    status: "Certified",
    updatedAt: "2026-07-28T13:00:00.000Z",
  },
  {
    id: "metric-budget-variance",
    name: "budget_variance_pct",
    displayName: "Budget Variance %",
    description: "Percentage difference between actual spend and approved budget.",
    domain: "Corporate Finance",
    owner: "FP&A",
    source: "Snowflake — Corporate Analytics",
    table: "FINANCE.BUDGET_ACTUALS",
    expression: "(SUM(ACTUAL) - SUM(BUDGET)) / NULLIF(SUM(BUDGET), 0) * 100",
    aggregation: "Calculated ratio",
    unit: "Percent",
    grain: "Cost center · month",
    dimensions: ["Cost Center", "Business Unit", "Fiscal Month"],
    synonyms: ["variance to plan", "budget overrun"],
    status: "Certified",
    updatedAt: "2026-07-26T15:30:00.000Z",
  },
  {
    id: "metric-program-burn",
    name: "program_burn_variance",
    displayName: "Program Burn Variance",
    description: "Difference between planned and actual program cost burn.",
    domain: "Program Management",
    owner: "PMO",
    source: "Snowflake — Corporate Analytics",
    table: "PROGRAM.PROGRAM_FINANCE",
    expression: "SUM(ACTUAL_BURN) - SUM(PLANNED_BURN)",
    aggregation: "Calculated amount",
    unit: "USD",
    grain: "Program · month",
    dimensions: ["Program", "Portfolio", "Fiscal Month"],
    synonyms: ["burn vs plan", "cost variance"],
    status: "Review",
    updatedAt: "2026-07-25T17:00:00.000Z",
  },
  {
    id: "metric-pwin",
    name: "pwin_weighted_value",
    displayName: "PWin Weighted Pipeline",
    description: "Opportunity value weighted by approved probability of win.",
    domain: "Proposals",
    owner: "Growth",
    source: "Snowflake — Corporate Analytics",
    table: "GROWTH.OPPORTUNITY_PIPELINE",
    expression: "SUM(OPPORTUNITY_VALUE * PWIN)",
    aggregation: "Sum",
    unit: "USD",
    grain: "Opportunity",
    dimensions: ["Customer", "Capture Manager", "Stage", "Due Quarter"],
    synonyms: ["weighted pipeline", "probability weighted value"],
    status: "Certified",
    updatedAt: "2026-07-24T12:00:00.000Z",
  },
];

// Starter dashboards are gone deliberately. They existed to give the
// localStorage workspace something to show; a workspace backed by the API
// starts genuinely empty, and seeding it with fixtures the user cannot refresh
// or export would misrepresent what the page does.

export const dashboardTopics = [
  "Corporate Finance",
  "Program Management",
  "Proposals",
  "Something Else",
] as const;

export const dashboardTemplates = [
  {
    name: "Executive Scorecard",
    detail: "Six KPI and trend views for leadership",
    charts: "6 charts",
  },
  {
    name: "Corporate Finance",
    detail: "Margin, budget, actuals, and variance",
    charts: "8 charts",
  },
  {
    name: "Program Delivery",
    detail: "Milestones, risk, cost, and schedule",
    charts: "7 charts",
  },
  {
    name: "Proposal Pipeline",
    detail: "PWin, value, stage, and due-date posture",
    charts: "6 charts",
  },
];
